import React from 'react'
import cx from 'classnames'

import { DescriptionIcon } from '@wf-sl/common-icons'
import propTypes from './props'

import styles from './icon-indication.module.css'

const defaultProps = {
    icon: <DescriptionIcon />,
    iconSize: 80
}

/**
 * Creates a simple element that shows a centered big icon with a text underneath. Can be used for many
 * information purposes. Most of all you can see it in action at:
 * https://confluence.tomtomgroup.com/display/TTB/Molecules#Molecules-NoData
 *
 * @example
 * <IconIndication icon={<NoPositionIcon/>}>Position Not Found</IconIndication>
 * <IconIndication>Random information</IconIndication>
 *
 * @param {element=<DescriptionIcon/>}  icon                - An SVG-icon element (try to use a <SvgIcon />-derived icon)
 * @param {number=80}                   iconSize            - the size of the icon
 * @param {string}                      className           - the css class to use for the wrapper styling
 * @param {string}                      classNameContent    - the css class to use for the content styling
 */
export default function IconIndication(props) {
    const { iconSize } = props
    const icon = React.cloneElement(props.icon, {
        className: styles['icon'],
        height: iconSize,
        width: iconSize
    })

    return (
        <div className={cx('t3sel-icon-indicaton', styles['wrapper'], props.className)}>
            <div className={cx(styles['content'], props.classNameContent)}>
                {icon}
                <div className={styles['text']}>{props.children}</div>
            </div>
        </div>
    )
}

IconIndication.propTypes = propTypes
IconIndication.defaultProps = defaultProps
